module.exports = __webpack_public_path__ + "img/BloodTypes.3479fa3b.svg";